import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { skillBitesSlice, userSlice, toastSlice } from '../../../reducers'
import { TranslateDialog, Alert, AlertTitle, Toast } from '../../../components'
import { useAlert, useTranslation } from '../../../hooks'
import { updateI18nLanguage } from '../../../services/i18n'

export const SkillBiteTranslateDialog = ({ open, onClose, onTranslate }) => {
  const { enqueueMsg } = useAlert()
  const { t, language } = useTranslation('skill_bite')
  const dispatch = useDispatch()

  const [setSkillBiteLanguage] = useEvent([
    {
      eventName: 'setSkillBiteLanguage',
      onSuccess: async (payload) => {
        await updateI18nLanguage(payload.skillBiteLanguage)
        dispatch(userSlice.actions.setUpdating(false))
        dispatch(userSlice.actions.setProfile(payload))
        dispatch(toastSlice.actions.showToast('set-skill-bite-language'))
      },
      onError: (err) => {
        dispatch(userSlice.actions.setUpdating(false))
        console.error('Unable to update default language', err)
        enqueueMsg(
          t('unable_to_update_language'),
          'error',
          t('error')
        )
        updateI18nLanguage(language)
      }
    }
  ])

  const handleSetDefaultLanguage = (languageCode) => {
    dispatch(userSlice.actions.setUpdating(true))
    setSkillBiteLanguage.trigger({ skillBiteLanguage: languageCode })
    onTranslate(languageCode)
  }

  const [getSkillBiteLanguages] = useEvent([
    skillBitesSlice.eventBus.getSkillBiteLanguages
  ])
  const showLanguageToast = useSelector((state) =>
    toastSlice.selectors.selectShowToast(state, 'set-skill-bite-language')
  )

  const skillBiteLanguage = useSelector(
    userSlice.selectors.selectSkillBiteLanguage
  )
  const skillBiteLanguages = useSelector(
    skillBitesSlice.selectors.selectSkillBiteLanguage
  )

  useEffect(() => {
    if (!skillBiteLanguages.length) {
      getSkillBiteLanguages.trigger()
    }
  }, [getSkillBiteLanguages, skillBiteLanguages])

  const handleToastClose = (name) => {
    dispatch(toastSlice.actions.hideToast(name))
  }

  return (
    <>
      <TranslateDialog
        open={open}
        heading={t('translate_dialog_heading')}
        subheading={t('translate_dialog_subheading')}
        label={t('translate_dialog_input_label')}
        formTip={t('translate_dialog_input_helper_text')}
        onClose={onClose}
        defaultLanguage={skillBiteLanguage}
        allLanguages={skillBiteLanguages}
        applyBtnText={t('apply')}
        cancelBtnText={t('cancel')}
        onTranslate={handleSetDefaultLanguage}
      />
      {showLanguageToast && (
        <Toast open onClose={() => handleToastClose('set-skill-bite-language')}>
          <Alert severity='success'>
            <AlertTitle>
              {t('translate_dialog_success_message')}
            </AlertTitle>
          </Alert>
        </Toast>
      )}
    </>
  )
}
